import { WithStyles, withStyles } from '@mui/styles';
import { Statistic } from '@tassat/common-definitions';

import { WalletsDashboard } from './wallets';
import { muiStyles } from './walletsStyles';

export interface IWalletsDeashboardProps extends WithStyles<typeof muiStyles> {
    userRole: string;
    clientStats: any;
    pageStatistics: {
        cardStatistics: Statistic[];
        headerPrimaryStats: Statistic[];
    };
}

export default withStyles(muiStyles)(WalletsDashboard);